import {
  AutocompleteLabelField,
  InputField,
  SelectField,
} from "@/features/FormCard/Fields";
import { Calculator } from "lucide-react";
import { FieldValues, UseFormReturn } from "react-hook-form";

type SecuritiesContentProps = {
  form: UseFormReturn<FieldValues>;
  currencyOptions: any[];
  calculateTotalFees: () => void;
};

export function SecuritiesFeeContent({
  form,
  currencyOptions,
  calculateTotalFees,
}: SecuritiesContentProps) {
  return (
    <div className="py-3">
      <div className="mb-2">
        <div className="text-xs">Frais de transaction pour titres</div>
      </div>

      <div className="flex flex-col gap-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <AutocompleteLabelField
            name="fee_currency"
            label="Devise du frais"
            control={form.control}
            options={currencyOptions}
          />
          <InputField
            name="broker_fee"
            label="Frais de courtage"
            control={form.control}
            type="number"
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <InputField
            name="custodian_broker_fee"
            label="Frais de courtage dépositaire"
            control={form.control}
            type="number"
          />
          <InputField
            name="other_fee"
            label="Autres frais"
            control={form.control}
            type="number"
          />
        </div>
        <InputField
          name="fees"
          label="Total des frais"
          control={form.control}
          type="number"
          endContent={
            <>
              <button
                type="button"
                onClick={calculateTotalFees}
                className="flex items-center gap-1 text-xs hover:bg-gray-100 rounded-md"
              >
                <Calculator size={14} />
                <span>Calculer</span>
              </button>
            </>
          }
        />
      </div>
    </div>
  );
}

type CashContentProps = {
  form: UseFormReturn<FieldValues>;
  isDisabled: boolean;
  feeOptionsTranslation?: {
    [key: string]: string;
  };
};

export function CashFeeContent({
  form,
  isDisabled,
  feeOptionsTranslation,
}: CashContentProps) {
  return (
    <div className="mb-2">
      <SelectField
        name="fee_type"
        label="Type de frais"
        control={form.control}
        options={feeOptionsTranslation}
        allow_empty_option={!isDisabled}
        fieldOptions={{
          isDisabled: isDisabled,
        }}
      />
    </div>
  );
}
